const addFormula = function() {
  let formula = this;
  formula.value[0].properties.forEach((f) => {
    delete f.add;
    f.remove = function() {
      removeFormila.call(formula,this);
    }
  });
  formula.value[0].properties.push({
    name: 'formula',
    alias: 'formula',
    canEdit: true,
    value: null,
    originalValue: null,
    add() {
      addFormula.call(formula,this);
    }
  });
}
const removeFormila = function(item) {
  let formula = this;
  let idx = formula.value[0].properties.indexOf(item);
  formula.value[0].properties.splice(idx,1);
}
const addSubPropertyDate = function() {
  let prop = this;
  prop.value[0].properties.forEach((v) => {
    if (v.ctrlType=='date') {
      delete v.add;
      v.remove = function() {
        removeSubPropertyDate.call(prop,this);
      }
    }
  });
  let date = {
    name: 'date',
    alias: prop.value[0].properties[0].alias,
    ctrlType: 'date',
    canEdit: true,
    value: null,
    originalValue: null,
    add() {
      addSubPropertyDate.call(prop,this);
    }
  };
  prop.value[0].properties.push(date);
  let formula = {
    name: prop.name,
    alias: prop.value[0].properties[1].alias,
    ctrlType: 'property',
    dataType: 'text',
    canEdit: true,
    value: [{
      //group: 'รายการ' + what,
      properties: []
    }]
  };
  prop.value[0].properties.push(formula);
  formula.value[0].properties.push({
    name: 'formula',
    alias: 'formula',
    canEdit: true,
    value: null,
    originalValue: null,
    add() {
      addFormula.call(formula,this);
    }
  });
}
const removeSubPropertyDate = function(item) {
  let prop = this;
  let idx = prop.value[0].properties.indexOf(item);
  prop.value[0].properties.splice(idx,2); //remove date and formula list
}
const setSubProperty = function(crop, value) {
  let prop = this;
  if (prop.value && prop.value[0] && value==prop.value) {
    return;
  }
  try {
    if (value && Object.prototype.toString.call(value) == "[object String]") {
      value = JSON.parse(value);
    }
  } catch (e) { value = null; }
  let what = prop.name=='fertilizer' ? 'ปุ๋ย' : 'สารเคมี';
  prop.originalValue = value || null;
  if (!value || Object.keys(value).length==0) {
    value = {
      undefined_date: [{formula:null}]
    };
  }
  prop.value = [{
    group: prop.alias,
    properties: []
  }];
  let date;
  let vi=0, vn = Object.keys(value).length - 1;
  for (let p in value) {
    date = {
      name: 'date',
      alias: 'วันที่ใส่' + what,
      ctrlType: 'date',
      canEdit: true,
      value: p.match(/undefined_date|null/i) ? null : p
    };
    if (vi<vn) {
      date.remove = function() {
        removeSubPropertyDate.call(prop,this);
      }
    } else {
      date.add = function() {
        addSubPropertyDate.call(prop);
      }
    }
    vi++;
    date.originalValue = date.value;
    prop.value[0].properties.push(date);
    if (value[p]) {
      let formula = {
        name: prop.name,
        alias: 'รายการ' + what,
        ctrlType: 'property',
        dataType: 'text',
        canEdit: true,
        value: [{
          //group: 'รายการ' + what,
          properties: []
        }]
      };
      prop.value[0].properties.push(formula);
      value[p].forEach((item) => {
        let idx = 0;
        for (let d in item) {
          if (d=='formula') {
            formula.value[0].properties.push({
              name: d,
              alias: d,
              canEdit: true,
              value: item[d],
              originalValue: item[d],
            });
          }
        }
      });
      let fn = formula.value[0].properties.length - 1;
      formula.value[0].properties.forEach((f,i) => {
        if (i<fn) {
          f.remove = function() {
            removeFormila.call(formula,this);
          }
        } else {
          f.add = function() {
            addFormula.call(formula,this);
          }
        }
      });
    }
  }
}
const calculateAge = function(dob) {
  let today = new Date();
  let yd = today.getFullYear();
  let md = today.getMonth();
  let dd = today.getDate();
  let yb = dob.getFullYear();
  let mb = dob.getMonth();
  let db = dob.getDate();
  let ma=0;
  let ya=0;
  let da = dd-db;
   // This is the all-important day borrowing code.
   if(da<0) {
      md--;
      // Borrow months from the year if necesssary.
      if(md<0) {
	      yd--;
        // Determine no. of months in year
        md += 12;
      }
      da += (new Date(yd,(md+1),0)).getDate();
   }
   ma = md - mb;
   // Month borrowing code - borrows months from years.
   if(ma<0) {
      yd--;
      ma += 12;
   }
   ya = yd - yb;

   return [ya,ma,da];
};
const getSubPropertyValue = function() {
  if (!(this.value && this.value[0])) {
    return {
      hasChanged: false,
      value: null
    };
  }
  let v = {};
  let props = this.value[0].properties;
  for (let i=0; i<props.length; i++) {
    let date = 'undefined_date';
    if (!!props[i].value) {
      try {
        new Date(props.value);
        date = props[i].value;
      } catch (error) {}
    }
    i++;
    let formula = props[i].value[0].properties;
    let f = [];
    for (let j=0; j<formula.length; j++) {
      let fv = {};
      if ((formula[j].value!=formula[j].originalValue) || 
          !!formula[j].value) {
        fv[formula[j].name] = formula[j].value;
        f.push(fv);
      }
    }
    if (f.length>0 || date!='undefined_date') {
      date = date || 'undefined_date';
      v[date] = f.length>0 ? f : null;
    }
  }
  let ov = JSON.stringify(this.originalValue || {}).replace(/\s/g,'').toLowerCase();
  let nv = JSON.stringify(v).replace(/\s/g,'').toLowerCase();
  return {
    hasChanged: nv!=ov,
    value: Object.keys(v).length>0 ? v : null
  };
}

export default {
  title: 'ข้อมูลแปลงปลูก',
  saveOrder: [{
      name: 'address',
      primary: 'hrn_pk',
      foreigns: { farmer:'hrn_fk' }
    },{
      name: 'farmer',
      primary: 'ssn_pk',
      foreigns: { farmland:'fssn_fk',farming:'farmer_ssn'}
    },{
      name: 'farmland',
      primary: 'gid',
      foreigns: { farming:'gid_fk' }
    },{
      // ensure that this is the last one so that will get gid_fk and farmer_ssn populated
      name: 'farming',
      primary: 'fid'
    }],
  items: [{
      group: 'ที่ตั้งแปลงและการเพาะปลูก',
      properties: [{
          alias: 'วันที่บันทึกข้อมูล',
          name: 'edit_ts_g',
          ctrlType: 'date'
        },{
          source: 'farmland',
          isKey: true,
          name: 'gid',
          ctrlType: 'hidden',
          dataType: 'number',
        },{
          name: 'province',
          alias: 'จังหวัด'
        },{
          name: 'amphoe',
          alias: 'อำเภอ'
        },{
          name: 'tambon',
          alias: 'ตำบล'
        },{
          name: 'village',
          alias: 'หมู่บ้าน'
        },{
          source: 'farmland',
          name: 'remark',
          alias: 'ชื่อจุด/หมายเหตุ',
          canEdit: true
        },{
          name: 'area_sqm',
          alias: 'เนื้อที่จากแผนที่',
          suffix: '(ตร.ม.)'
        },{
          name: 'area_rai_ngan_sqwah',
          alias: 'เนื้อที่จากแผนที่'
        },{
          source: 'farming',
          name: 'deed_rai',
          alias: 'เนื้อที่ตามเอกสาร',
          suffix: '(ไร่)',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farming',
          name: 'deed_ngan',
          alias: 'เนื้อที่ตามเอกสาร',
          suffix: '(งาน)',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farming',
          name: 'deed_sqwah',
          alias: 'เนื้อที่ตามเอกสาร',
          suffix: '(ตร.วา)',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farming',
          name: 'farm_rai',
          alias: 'เนื้อที่ปลูก',
          suffix: '(ไร่)',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farming',
          name: 'farm_ngan',
          alias: 'เนื้อที่ปลูก',
          suffix: '(งาน)',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farming',
          name: 'farm_sqwah',
          alias: 'เนื้อที่ปลูก',
          suffix: '(ตร.วา)',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: { farmland:'type_fk',farming:'type_fk' },
          name: 'type_fk_g',
          alias: 'ประเภทพืช',
          mandatory: true,
          ctrlType: 'select',
          canEdit: true,
          dataType: 'integer',
          options: [],
          loadOptions: async function(user, value) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/crop_types');
            } catch (error) {}
          },
          onOptionChange: function(properties) {
            properties[17].options = [];
            if (this.value!=this.originalValue) {
              properties[17].value = null;
              properties[16].value = null;
            }
            properties[16].fetchOptions(this.user, this.value);
          }
        },{
          source: { farmland:'genus_fk',farming:'genus_fk' },
          name: 'genus_fk_g',
          alias: 'ชนิดพืช',
          mandatory: true,
          isMandatory: true,
          canEdit: true,
          ctrlType: 'select',
          dataType: 'integer',
          options: [],
          fetchOptions: async function(user, value) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/crop_genera/' + value);
              /*if (this.value) {
                let inOptions = false;
                //in case that type_fk_g is changed after loaded
                for (let i=0; i<this.options.length && !inOptions; i++) {
                  inOptions = (this.options[i].code == this.value);
                }
                if (!inOptions) {
                  this.value = null;
                }
              }*/
            } catch (error) {}
          },
          onOptionChange: function(properties) {
            if (this.value) {
              properties[17].options = [];
              if (this.value!=this.originalValue) {
                properties[17].value = null;
              }
              properties[17].fetchOptions(this.user, this.value);
              /*if (this.value) {
                let inOptions = false;
                //in case that genus_fk_g is changed after loaded
                for (let i=0; i<this.options.length && !inOptions; i++) {
                  inOptions = (this.options[i].code == this.value);
                }
                if (!inOptions) {
                  this.value = null;
                }
              }*/
            }
          }
        },{
          source: { farmland:'crop_fk',farming:'crop_fk' },
          name: 'crop_fk_g',
          alias: 'พันธุ์พืช',
          //isMandatory: true,
          canEdit: true,
          ctrlType: 'select',
          dataType: 'integer',
          options: [],
          fetchOptions: async function(user, value) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/crop_species/' + value);
            } catch (error) {}
          }
        },{
          source: 'farmland',
          name: 'wrsc_fk',
          alias: 'ประเภทแหล่งน้ำ',
          ctrlType: 'select',
          canEdit: true,
          dataType: 'integer',
          options: [{
            code: 10,
            name: 'ระบบชลประทาน'
          }, {
            code: 20,
            name: 'แหล่งน้ำธรรมชาติ'
          }, {
            code: 30,
            name: 'น้ำฝน'
          }, {
            code: 40,
            name: 'น้ำประปา'
          }, {
            code: 50,
            name: 'น้ำบาดาล'
          }]
        },{
          source: { farmland:'deed_type',farming:'deed_type' },
          name: 'deed_type_g',
          alias: 'ประเภทเอกสารสิทธิ์',
          ctrlType: 'select',
          canEdit: true,
          dataType: 'text',
          options: [],
          loadOptions: async function(user, value) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/deed_types');
            } catch (error) {}
          },
        },{
          source: { farmland:'deed_no',farming:'deed_no' },
          name: 'deed_no_g',
          alias: 'เลขที่เอกสารสิทธิ์',
          dataType: 'text',
          canEdit: true
        },{
          source: 'farming',
          name: 'land_nth',
          alias: 'ที่ดินแปลงที่',
          //isMandatory: true,
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farming',
          name: 'ownership',
          alias: 'ความเป็นเจ้าของ',
          ctrlType: 'select',
          canEdit: true,
          dataType: 'text',
          options:[
            {code:'ของตนเอง',name:'ของตนเอง'},
            {code:'ของครัวเรือน',name:'ของครัวเรือน'},
            {code:'เช่า',name:'เช่า'},
            {code:'เช่า(มีสัญญา)',name:'เช่า(มีสัญญา)'},
            {code:'เช่า(ไม่มีสัญญา)',name:'เช่า(ไม่มีสัญญา)'},
            {code:'อื่นๆ (ไม่ระบุ)',name:'อื่นๆ (ไม่ระบุ)'}
          ]
        }]
    },{
      group: 'สภาพแปลงตามกายภาพ',
      properties: [{
          name: 'soil_fk',
          alias: 'สภาพดิน'
        },{
          name: 'suitability',
          alias: 'ความเหมาะสมของดิน',
          ctrlType: 'property',
          loadOptions: async function(user, gid, template) {
            let data;
            try {
              data = await user.requestResource('mis/land_suitability/' + gid);
            } catch (error) {}
            let v = Object.assign({},template);
            if (data) {
              data.forEach((d) => {
                v[d.crop] = d.suitability;
              });
            }
            this.value = [{
              group: this.alias,
              properties: []
            }];
            for (let p in v) {
              this.value[0].properties.push({
                name: p,
                alias: p,
                value: v[p]
              });
            }
            this.originalValue = this.value;
          }
        },{
          name: 'flooded_year',
          alias: 'ปีที่เกิดอุทกภัย',
          loadOptions: async function(user, gid) {
            let data;
            try {
              data = await user.requestResource('mis/land_flooded_year/' + gid);
            } catch (error) {}
            if (data) {
              this.originalValue = this.value = data[0].flooded_year;
            }
          }
        },{
          name: 'irrigation',
          alias: 'เขตชลประทาน'
        },{
          name: 'alro_area',
          alias: 'เขต ส.ป.ก.'
        },{
          name: 'in_conserved',
          alias: 'ทับซ้อนเขตป่า',
          ctrlType: 'textarea',
          highlight: true
        }]
    },{
      group: 'ข้อมูลเกษตรกร',
      properties: [{
          source: 'farming',
          name: 'program_period',
          alias: 'ปีที่แจ้งขึ้นทะเบียน',
          canEdit: true,
          suffix: '(พ.ศ.)'
        },{
          source: 'farming',
          name: 'reg_date_dt',
          alias: 'วันที่ขึ้นทะเบียน',
          ctrlType: 'date',
          canEdit: true
        },{
          source: 'farmland',
          name: 'fssn_ts',
          alias: 'วันที่เชื่อมทะเบียน',
          ctrlType: 'date'
        },{
          source: 'farmer',
          name: 'photo',
          alias: 'รูปถ่าย (128x128px)<br/>คลิกที่รูปด้านขวา<br/>เพื่ออัพโหลดรูป<br/>(*.png | *.gif | *.jpg)',
          ctrlType: 'photo',
          canEdit: true,
          photoUrl: function() {
            //todo this.value is either ssn or base64
            let url;
            if (this.value) {
              url = '/rest/image/farmer/photo/' + this.value;
            } else {
              url = '/static/images/ppix_enabled.png';
            }
            return url;
          }
        },{
          // this should be declared before ssn_pk
          source: 'farmland',
          name: 'fssn_fk',
          isKey: true,
          ctrlType: 'hidden',
          dataType: 'integer'
        },{
          // this should be declared before ssn_pk
          source: 'farming',
          name: 'farmer_ssn',
          isKey: true,
          ctrlType: 'hidden',
          dataType: 'integer'
        },{
          source: 'farmer',
          isKey: true,
          mandatory: true, //required if any other fields of the same source is changed
          name: 'ssn_pk',
          alias: 'เลขประจำตัว',
          placeholder: 'เลข 13 หลัก',
          dataType: 'integer',
          canEdit: true,
          validate: function() {
            return this.value && this.user && this.user.validateThaiId(this.value);
          },
          autoSearch: async function(user, properties) {
            try {
              if (this.value!=this.originalValue) {
                if (!this.value || user.validateThaiId(this.value)) {
                  let farmer;
                  if (!this.value) {
                    farmer = {
                      address: {
                        addr_aa3: null,
                        addr_aa4: null,
                        addr_aa5: null,
                        alley_th: null,
                        building_th: null,
                        door_no: null,
                        floor_nn: null,
                        hrn_pk: null,
                        street_th: null,
                        vill_no: null,
                        vill_th: null,
                        zip_code: null
                      },
                      email: null,
                      gender: null,
                      mobile: null,
                      occupation: null,
                      orgc_fk_p: null,
                      photo: null,
                      ssn_pk: null,
                      title_th: null,
                      name_th: null,
                      surname_th: null,
                      fssn_ts: null
                    };
                  } else {
                    this.searching = true;
                    farmer = await user.requestResource('mis/farmer/'+this.value);
                    farmer = farmer[0];
                    farmer.fssn_ts = (new Date()).toISOString().substr(0,10);
                    this.searching = false;
                  }
                  let i, f, a;
                  if (this.featureOnMap) {
                    //sync properties of its feature on the map
                    //these attrs are used for labelling and coloring
                    [ /*'fssn_ts','fssn_cyy','fssn_fyy','fssn_cym','fssn_fym',*/
                      'title_th','title_en','title_zh',
                      'name_th','name_en','name_zh',
                      'surname_th','surname_en','surname_zh'
                    ].forEach((prop) => {
                      this.featureOnMap.set(prop,farmer[prop]);
                    });
                    this.featureOnMap.set('fssn_ts', farmer.fssn_ts);
                    this.featureOnMap.set('fssn_fk',farmer.ssn_pk);
                  }
                  for (f in farmer) {
                    if (f=='address') {
                      for (a in farmer.address) {
                        for (i=0; i<properties.length; i++) {
                          if (properties[i].name=='hrn_fk') {
                            properties[i].value = farmer.address.hrn_pk;
                          } else if (properties[i].name==a) {
                            properties[i].value = farmer.address[a];
                            properties[i].originalValue = farmer.address[a];
                            break;
                          }
                        }
                      }
                    } else {
                      for (i=0; i<properties.length; i++) {
                        if (properties[i].name==f) {
                          properties[i].value = farmer[f];
                          properties[i].originalValue = farmer[f];
                          break;
                        }
                        if (properties[i].name=='fssn_fk' || properties[i].name=='farmer_ssn') {
                          properties[i].value = this.value;
                        }
                      }
                    }
                  }
                } else {
                  throw({
                    status: 400,
                    id: 'bad_request',
                    message: 'Invalid value'
                  });
                }
              }
            } catch (error) {
              this.searching = false;
              throw(error);
            }
          }
        },{
          source: 'farmer',
          name: 'title_th',
          alias: 'คำนำหน้าชื่อ',
          mandatory: true,
          ctrlType: 'select',
          canEdit: true,
          options: [],
          loadOptions: async function(user, value) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/person_title');
            } catch (error) {}
          }
        },{
          source: 'farmer',
          name: 'name_th',
          alias: 'ชื่อเกษตรกร',
          mandatory: true,
          canEdit: true
        },{
          source: 'farmer',
          name: 'surname_th',
          mandatory: true,
          alias: 'นามสกุล',
          canEdit: true
        },{
          source: 'farmer',
          name: 'email',
          alias: 'อีเมล์',
          dataType: 'text',
          canEdit: true
        },{
          source: 'farmer',
          name: 'mobile',
          alias: 'หมายเลขมือถือ',
          dataType: 'digits',
          mask: '0-##-###-####',
          canEdit: true
        },{
          source: 'farmer',
          name: 'hrn_fk',
          isKey: true,
          ctrlType: 'hidden',
          dataType: 'integer'
        },{
          source: 'address',
          isKey: true,
          name: 'hrn_pk',
          alias: 'เลขรหัสประจำบ้าน',
          placeholder: 'เลข 11 หลัก',
          dataType: 'integer',
          canEdit: true,
          validate: function() {
            let v = !!this.value ? this.value + '' : null;
            return !v || (v.length==11 && (parseFloat(v)==v));
          },
          autoSearch: async function(user, properties) {
            try {
              if (this.validate()) {
                let address;
                if (!this.value) {
                  address = {
                    addr_aa3: null,
                    addr_aa4: null,
                    addr_aa5: null,
                    alley_th: null,
                    building_th: null,
                    door_no: null,
                    floor_nn: null,
                    hrn_pk: null,
                    street_th: null,
                    vill_no: null,
                    vill_th: null,
                    zip_code: null
                  };
                } else {
                  this.searching = true;
                  address = await user.requestResource('mis/address/'+this.value);
                  address = address[0];
                  this.searching = false;
                }
                let i,a;
                for (a in address) {
                  for (i=0; i<properties.length; i++) {
                    if (properties[i].name=='hrn_fk') {
                      properties[i].value = this.value;
                    } else if (properties[i].name==a) {
                      properties[i].value = address[a];
                      properties[i].originalValue = address[a];
                      break;
                    }
                  }
                }
              } else {
                throw({
                  status: 400,
                  id: 'bad_request',
                  message: 'Invalid value'
                });
              }
            } catch (error) {
              this.searching = false;
              throw(error);
            }
          }
        },{
          source: 'address',
          name: 'door_no',
          alias: 'เลขที่บ้าน',
          fieldSet: 2,
          canEdit: true
        },{
          source: 'address',
          name: 'floor_nn',
          alias: 'ชั้นที่',
          placeholder: 'ตัวเลข',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'address',
          name: 'building_th',
          alias: 'อาคาร',
          dataType: 'text',
          canEdit: true
        },{
          source: 'address',
          name: 'vill_no',
          alias: 'หมู่ที่',
          canEdit: true
        },{
          source: 'address',
          name: 'vill_th',
          alias: 'หมู่บ้าน',
          canEdit: true
        },{
          source: 'address',
          name: 'alley_th',
          alias: 'ซอย',
          canEdit: true
        },{
          source: 'address',
          name: 'street_th',
          alias: 'ถนน',
          canEdit: true
        },{
          name: 'addr_aa3',
          alias: 'จังหวัด',
          ctrlType: 'select',
          dataType: 'integer',
          canEdit: true,
          options: [],
          loadOptions: async function(user, aac3) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/province');
            } catch (error) {}
          },
          onOptionChange: function(properties) {
            properties[23].options = []; //addr_aa5
            properties[22].fetchOptions(this.user, this.value); //addr_aa4
          }
        },{
          name: 'addr_aa4',
          alias: 'อำเภอ',
          ctrlType: 'select',
          canEdit: true,
          dataType: 'integer',
          options: [],
          fetchOptions: async function(user, aac3) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/amphoe/' + aac3);
            } catch (error) {}
          },
          onOptionChange: function(properties) {
            properties[23].fetchOptions(this.user, this.value);
          }
        },{
          source: { address:'aac5_fk'},
          name: 'addr_aa5',
          alias: 'ตำบล',
          ctrlType: 'select',
          canEdit: true,
          dataType: 'integer',
          options: [],
          fetchOptions: async function(user, aac4) {
            try {
              this.user = user;
              this.options = await user.requestResource('codelist/tambon/' + aac4);
            } catch (error) {}
          }
        },{
          source: 'address',
          name: 'zip_code',
          alias: 'รหัสไปรษณีย์',
          placeholder: 'เลข 5 หลัก',
          dataType: 'integer',
          canEdit: true
        },{
          source: 'farmer',
          name: 'occupation',
          alias: 'อาชีพ',
          canEdit: true
        },{
          source: { farmer:'orgc_fk' },
          name: 'orgc_fk_p',
          alias: 'สมาชิกกลุ่ม',
          canEdit: true
        },{
          source: { farmer:'income_baht' },
          name: 'income_baht',
          alias: 'รายได้ต่อปี',
          suffix: '(บาท/ปี)',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true
        },{
          source: { farmer:'loan_baht' },
          name: 'loan_baht',
          alias: 'หนี้สินรวม',
          suffix: '(บาท)',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true
        },{
          source: 'farming',
          name: 'aac5_fk',
          dataType: 'integer',
          ctrlType: 'hidden'
        },{
          source: 'farming',
          name: 'orgc_fk',
          dataType: 'integer',
          ctrlType: 'hidden'
        },{
          source: 'farming',
          name: 'orgc_ref',
          dataType: 'integer',
          ctrlType: 'hidden'
        }]
    },{
      group: 'การประเมินผลผลิต',
      properties: [{
          source: 'farming',
          isKey: true,
          name: 'fid',
          ctrlType: 'hidden',
          dataType: 'number'
        },{
          source: 'farming',
          isKey: true,
          name: 'gid_fk',
          ctrlType: 'hidden',
          dataType: 'number'
        },{
          source: 'farming',
          name: 'grow_dt',
          alias: 'วันที่ปลูก',
          mandatory: true,
          ctrlType: 'date',
          canEdit: true,
          onChange: function(properties) {
            let ymd = calculateAge(new Date(this.value));
            let L = require('../../../src/common/filters').L;
            let age = '';
            if (ymd[0]>0) {
              age += ymd[0] + ' ' + L('years',[ymd[0]==1 ? '' : 's']);
            }
            if (ymd[1]>0 || ymd[2]>0) {
              age += ' ' + ymd[1] + ' ' + L('months',[ymd[1]==1 ? '' : 's']);
            }
            if (ymd[2]>0) {
              age += ' ' + ymd[2] + ' ' + L('days',[ymd[2]==1 ? '' : 's']);
            }
            properties[3].value = age;
          }
        },{
          name: 'plant_age',
          alias: 'อายุพืช (ปี)'
        },{
          source: 'farming',
          name: 'blossom_dt',
          alias: 'วันที่ออกดอก',
          ctrlType: 'date',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'harvest_dt',
          alias: 'วันที่เริ่มเก็บเกี่ยว',
          mandatory: true,
          ctrlType: 'date',
          canEdit: true
        },{
          source: 'farming',
          name: 'harvest_days',
          alias: 'รอบวันเก็บเกี่ยว',
          suffix: '(วัน)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'tree_space',
          alias: 'ระยะห่างระหว่างต้น',
          suffix: '(ม.)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'row_space',
          alias: 'ระยะห่างระหว่างแถว',
          suffix: '(ม.)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'trees_pr',
          alias: 'จำนวนต้น/ไร่',
          suffix: '(ต้น/ไร่)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if ((crop.type_fk_g==24) || 
                ((crop.type_fk_g==25) && (crop.genus_fk_g==250110))) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'trees_total',
          alias: 'จำนวนต้นทั้งหมด',
          suffix: '(ต้น)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if ((crop.type_fk_g==24) || 
                ((crop.type_fk_g==25) && (crop.genus_fk_g!=250110))) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'canopy_size',
          alias: 'ขนาดทรงพุ่ม',
          ctrlType: 'select',
          dataType: 'text',
          canEdit: true,
          options: [{
            code:'ใหญ่',name:'ขนาดใหญ่'
          },{
            code:'ปานกลาง',name:'ขนาดปานกลาง'
          },{
            code:'เล็ก',name:'ขนาดเล็ก'
          }],
          setProperty(crop) {
            if (crop.type_fk_g==24) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'bouquet_pt',
          alias: 'จำนวนช่อดอก/ต้น',
          suffix: '(ดอก/ต้น)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          name: 'fertilizer',
          alias: 'การใช้ปุ๋ย',
          ctrlType: 'property',
          dataType: 'json',
          canEdit: true,
          setProperty(crop,value) {
            setSubProperty.call(this,crop,value);
          },
          getValue() {
            return getSubPropertyValue.call(this)
          }
        },{
          source: 'farming',
          name: 'catalyzer',
          alias: 'การใช้สารเคมีเร่งผลผลิต',
          ctrlType: 'property',
          dataType: 'json',
          canEdit: true,
          setProperty(crop,value) {
            setSubProperty.call(this,crop,value);
          },
          getValue() {
            return getSubPropertyValue.call(this)
          }
        },{
          source: 'farming',
          name: 'pesticide',
          alias: 'การใช้สารเคมีป้องกันโรคแมลง',
          ctrlType: 'property',
          dataType: 'json',
          setProperty(crop,value) {
            setSubProperty.call(this,crop,value);
          },
          getValue() {
            return getSubPropertyValue.call(this)
          }
        },{
          source: 'farming',
          name: 'standards',
          alias: 'มาตรฐาน',
          ctrlType: 'property',
          dataType: 'json',
          canEdit: true,
          setProperty(crop, value) {
            if (Object.prototype.toString.call(value) == "[object Array]" && 
                value==this.value) {
              value = {};
            } else {
              if (value && Object.prototype.toString.call(value) == "[object String]") {
                value = JSON.parse(value);
              }
              this.originalValue = value || null;
              value = value || {};
            }
            let v = {};
            if (crop.genus_fk_g=='250110') {
              v.rspo = (value.rspo!=undefined) ? value.rspo : null;
            } else {
              ['gap','organicFood'].forEach((p) => {
                v[p] = value[p]!=undefined ? value[p] : null;
              });
            }
            this.value = [{
              group: this.alias,
              properties: []
            }];
            for (let p in v) {
              this.value[0].properties.push({
                name: p,
                alias: p,
                ctrlType: 'radio',
                dataType: 'boolean',
                canEdit: true,
                options: [
                  {code:1,name:'ใช่'},
                  {code:0,name:'ไม่ใช่'}
                ],
                value: v[p]===true ? 1 : v[p]===false ? 0 : null
              });
            }
          },
          getValue() {
            let v = {};
            let originalValue = this.originalValue || {};
            let hasChanged = false;
            //must return all standards even if one is null
            this.value[0].properties.forEach((prop) => {
              let pv = prop.value===null ? null : !!prop.value;
              v[prop.name] = pv;
              hasChanged = hasChanged || (originalValue[prop.name]!=pv);
            });
            return {
              hasChanged: hasChanged,
              value: Object.keys(v).length>0 ? v : null
            };
          }
        },{
          source: 'farming',
          name: 'standard_others',
          alias: 'มาตรฐานอื่นๆ',
          canEdit: true
        },{
          source: 'farming',
          alias: 'ราคาสายพันธุ์',
          suffix: '(บาท/ต้น)',
          name: 'cost_breed_bpt',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          alias: 'ต้นทุนการปลูก',
          suffix: '(บาท/ไร่)',
          name: 'cost_growing_bpr',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          alias: 'ต้นทุนการผลิต',
          suffix: '(บาท/ไร่/ปี)',
          name: 'cost_growing_bpr',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          alias: 'ผลผลิต',
          suffix: '(ตัน/ไร่/ปี)',
          name: 'production_tpry',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          alias: 'ผลผลิตที่',
          suffix: '(ตัน)',
          name: 'production_ton',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'ผลผลิตเกรดดีมาก/AA',
          suffix: '(ตัน)',
          name: 'production_aa',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'ผลผลิตเกรดดี/A',
          suffix: '(ตัน)',
          name: 'production_a',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'ผลผลิตเกรดพอใช้/B',
          suffix: '(ตัน)',
          name: 'production_b',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'ผลผลิตเกรดต่ำกว่ามาตรฐาน/C',
          suffix: '(ตัน)',
          name: 'production_c',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'ราคาผลผลิต',
          suffix: '(บาท/กก.)',
          name: 'price_bpkg',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'การจำหน่ายผลผลิต',
          name: 'market',
          ctrlType: 'radio',
          dataType: 'text',
          canEdit: true,
          options: [
            {code:'เหมา',name:'เหมา'},
            {code:'ขายสด',name:'ขายสด'}
          ]
        },{
          source: 'farming',
          alias: 'แหล่งรับซื้อ',
          name: 'buyer',
          dataType: 'text',
          canEdit: true,
        },{
          source: 'farming',
          alias: 'จำนวนพื้นที่เสียหาย',
          suffix: '(ไร่)',
          name: 'lost_area',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          source: 'farming',
          alias: 'จำนวนที่เสียหาย',
          suffix: '(ต้น)',
          name: 'lost_trees',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          canEdit: true,
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          source: 'farming',
          alias: 'สาเหตุที่เสียหาย',
          name: 'lost_cause',
          dataType: 'text',
          canEdit: true,
        },{
          source: 'farming',
          alias: 'ระดับความเสียหาย',
          name: 'lost_claim',
          ctrlType: 'select',
          dataType: 'text',
          canEdit: true,
          options: [
            {code:'เสียหายมาก', name:'เสียหายมาก'},
            {code:'เสียหายปานกลาง', name:'ปานกลาง'},
            {code:'เสียหายเล็กน้อย', name:'เล็กน้อย'},
            {code:'ไม่มีความเสียหาย', name:'ไม่มีความเสียหาย'},
            {code:'', name:'ไม่ทราบ'}
          ]
        },{
          alias: 'วันที่บันทึกข้อมูล',
          name: 'edit_ts_g',
          ctrlType: 'date'
        }]
    }]
};

//used for saveing feature
export const farmland = {
  gid: { source:{  farmland:'gid' }, dataType:'integer'},
  //geom: 'Polygon',
  area_sqm: { source:{  farmland:'area_sqm' }, dataType:'number' },
  /*area_rai: 'number',
  area_ngan: 'number',
  area_sqwah: 'number',
  angle: 'number',
  centroid_lon: 'number',
  centroid_lat: 'number',
  centroid_utmx: 'number',
  centroid_utmy: 'number',
  utm_zone: 'number',
  aag1_fk: 'text',
  aag2_fk: 'number',
  aag3_fk: 'number',
  aag4_fk: 'number',
  aag5_fk: 'number',
  aag6_fk: 'number',
  lulc_fk: 'number',
  soil_fk: 'text',*/
  wrsc_fk: { source:{  farmland:'wrsc_fk' }, dataType:'number' },
  /*irrigation: 'text',
  suitability: 'text',
  agro_zone: 'text',
  in_conserved: 'text',
  status: 'number',*/
  type_fk_g: {source: { farmland:'type_fk',farming:'type_fk' }, dataType:'integer' },
  genus_fk_g: {source: { farmland:'genus_fk',farming:'genus_fk' }, dataType:'integer' },
  crop_fk_g: {source: { farmland:'crop_fk',farming:'crop_fk' }, dataType:'integer' },
  fssn_fk: {source: { person:'ssn_pk', farmland:'fssn_fk',farming:'farmer_ssn' }, dataType:'number' },
  /*fssn_fyy: 'number',
  fssn_cyy: 'number',
  fssn_fym: 'number',
  fssn_cym: 'number',*/
  deed_no_g: {source: { farmland:'deed_no',farming:'deed_no' }, dataType:'text' },
  deed_type_g: {source: { farmland:'deed_type',farming:'deed_type' }, dataType:'text' },
  /*create_ts_g: 'time',
  create_fyy: 'number',
  create_cyy: 'number',
  create_fym: 'number',
  create_cym: 'number',
  edit_ts_g: 'time',*/
  user_fk_g: {source: { farmland:'user_fk',farming:'user_fk' }, dataType:'text' },
  /*guid: 'text',
  puid: 'text',*/
  org_code: {source: { farmland:'org_code',farming:'orgc_fk' }, dataType:'text' },
  org_key: {source: { farmland:'org_key',farming:'orgc_ref' }, dataType:'text' },
  /*project: 'text',*/
  remark: {source: { farmland:'remark' }, dataType:'text' },
  //notes_g: 'text'

  //farmer
  ssn_pk: { source: { person:'ssn_pk', farmland:'fssn_fk',farming:'farmer_ssn' }, dataType:'number' },
  title_th: { source: { person:'title_th' }, dataType:'text' },
  name_th: { source: { person:'name_th' }, dataType:'text' },
  surname_th: { source: { person:'surname_th' }, dataType:'text' },
  /*title_en: 'text',
  name_en: 'text',
  surname_en: 'text',
  title_zh: 'text',
  name_zh: 'text',
  surname_zh: 'text',*/
  gender: { source: { person:'gender' }, dataType:'number' },
  //photo:'number',
  //photo_fmt: 'text',
  email: { source: { person:'email' }, dataType:'text' },
  mobile: { source: { person:'mobile' }, dataType:'text' },
  //social_id: 'hstore',
  //hrn_fk: 'number',
  occupation: { source: { person:'occupation' }, dataType:'text' },
  orgc_fk_p: { source: { person:'orgc_fk' }, dataType:'text' },
  income_baht: { source: { person:'income_baht' }, dataType:'number' },
  loan_baht: { source: { person:'loan_baht' }, dataType:'number' },

  // address
  hrn_pk: { source: { address:'hrn_pk', person:'hrn_fk' }, dataType:'number' },
  door_no: { source: { address:'door_no' }, dataType:'text' },
  vill_no: { source: { address:'vill_no' }, dataType:'text' },
  vill_th: { source: { address:'vill_th' }, dataType:'text' },
  addr_aa5: { source: { address:'aac5_fk' }, dataType:'integer' },

  //farming
  fid: {source: { farming:'fid' }, dataType:'integer' },
  aac5_fk: {source: { farming:'aac5_fk' }, dataType:'integer' },
  /*aac6_fk: 'number',*/
  reg_date_dt: {source: { farming:'reg_date_dt' }, dataType:'date' },
  orgc_fk: {source: { farmland:'org_code',farming:'orgc_fk' }, dataType:'text' },
  orgc_ref: {source: { farmland:'org_key',farming:'orgc_ref' }, dataType:'text' },
  program_period: {source: { farming:'program_period' }, dataType:'text' },
  //program_nth: 'number',
  //register_nth: 'number',
  land_nth: {source: { farming:'land_nth' }, dataType:'number' },
  parcel_no: {source: { farming:'parcel_no' }, dataType:'text' },
  ownership: {source: { farming:'ownership' }, dataType:'text' },
  deed_no: {source: { farmland:'deed_no',farming:'deed_no' }, dataType:'text' },
  deed_type: {source: { farmland:'deed_type',farming:'deed_type' }, dataType:'text' },
  //deed_doc_path: 'text',
  deed_rai: {source: { farming:'deed_rai' }, dataType:'number' },
  deed_ngan: {source: { farming:'deed_ngan' }, dataType:'number' },
  deed_sqwah: {source: { farming:'deed_sqwah' }, dataType:'number' },
  farm_rai: {source: { farming:'farm_rai' }, dataType:'number' },
  farm_ngan: {source: { farming:'farm_ngan' }, dataType:'number' },
  farm_sqwah: {source: { farming:'farm_sqwah' }, dataType:'number' },
  farmer_ssn: {source: { person:'ssn_pk', farmland:'fssn_fk',farming:'farmer_ssn' }, dataType:'number' },
  type_fk: {source: { farmland:'type_fk',farming:'type_fk' }, dataType:'integer' },
  genus_fk: {source: { farmland:'genus_fk',farming:'genus_fk' }, dataType:'integer' },
  crop_fk: {source: { farmland:'crop_fk',farming:'crop_fk' }, dataType:'integer' },
  //in_season: 'text',
  grow_dt: {source: { farming:'grow_dt' }, dataType:'date' },
  //grow_yyyy: 'number',
  //grow_yyyymm: 'number',
  blossom_dt: {source: { farming:'blossom_dt' }, dataType:'date' },
  harvest_dt: {source: { farming:'harvest_dt' }, dataType:'date' },
  harvest_days: {source: { farming:'harvest_days' }, dataType:'integer' },

  /*harvest_yyyy: 'number',
  harvest_yyyymm: 'number',

  tree_space: {source: { farming:'tree_space' }, dataType:'number' },
  row_space: {source: { farming:'row_space' }, dataType:'number' },
  trees_pr: {source: { farming:'trees_pr' }, dataType:'integer' },
  trees_total: {source: { farming:'trees_total' }, dataType:'integer' },
  canopy_size: {source: { farming:'canopy_size' }, dataType:'text' },
  bouquet_nn: {source: { farming:'bouquet_nn' }, dataType:'integer' },
  
  pesticide: 'text',
  catalyzer: 'text',
  fertilizer: 'text',
  std_yes: 'boolean',
  std_gap: 'boolean',
  std_organic_food: 'boolean',
  std_others: 'text',
  yield_ton: 'number',
  sold_ton: 'number',
  sold_aa_ton: 'number',
  sold_a_ton: 'number',
  sold_b_ton: 'number',
  sold_c_ton: 'number',
  unit_price: 'number',
  market: 'text',
  buyer: 'text',
  lost_trees: 'number',
  lost_cause: 'text',
  lost_claim: 'text',
  uuid: 'text',
  gid_fk: 'number', //farmland->gid
  guid_fk: 'text',
  pid_fk: 'number', //farmland_point->gid
  puid_fk: 'text',
  create_ts: 'time',
  edit_ts: 'time',
  user_fk: 'text',
  notes: 'text'*/
}

/*export const address = {
  hrn_pk: 'number',
  door_no: 'text',
  vill_no: 'text',
  vill_th: 'text',
  vill_en: 'text',
  vill_zh: 'text',
  floor_nn: 'number',
  building_th: 'text',
  building_en: 'text',
  building_zh: 'text',
  alley_no: 'text',
  alley_th: 'text',
  alley_en: 'text',
  alley_zh: 'text',
  street_no: 'text',
  street_th: 'text',
  street_en: 'text',
  street_zh: 'text',
  zip_code: 'number',
  aac5_fk: 'number',
  longitude: 'number',
  latitude: 'number'
}*/

// for data sbumitted from doae
// mapping to gisagro.v_lfg_farmland_farming
// then use feature.properties to build mapInfo against default schema as defined at the top most
// use the mapInfo to show attributes or save to database
export const doae_mappping = {
  DEPARTMENT: { name:'org_code', dataType:'text' }, //alwaysed save using User.Organization.Code
  //PROFILE_CENTER_ID: 1976536, //NA
  REGISTER_DATE: { name:'reg_date_dt', dataType:'date' },
  PROFILE_IDCARD: { name:'ssn_pk', dataType:'number' },
  PROFILE_PREFIX: { name:'title_th', dataType:'text' },
  PROFILE_NAME: { name:'name_th', dataType:'text' },
  PROFILE_SURNAME: { name:'surname_th', dataType:'text' },
  PROFILE_GENDER: { name:'gender', dataType:'number' },
  //PROFILE_BIRTHDAY: 25051220, //NA
  PROFILE_IDHOUSE: { name:'hrn_pk', dataType:'number' },
  PROFILE_HOUSENUMBER1: { name:'door_no', dataType:'text' },
  PROFILE_MOO1: { name:'vill_no', dataType:'text' },
  PROFILE_VILLEGE1: { name:'vill_th', dataType:'text' },
  PROFILE_TAMBON1: { name:'addr_aa5', dataType:'number' },
  //PROFILE_TELEPHONE: 029551642, //NA
  PROFILE_MOBILE: { name:'mobile', dataType:'text' },
  PROFILE_MAIL: { name:'email', dataType:'text' },
  TAMBON_CODE: { name:'aac5_fk', dataType:'number' },
  //PROFILE_AREA_ID: 50015711, //NA
  AREA_YEAR: { name:'program_period', dataType:'text' },
  AREA_NUM: { name:'land_nth', dataType:'number' },
  AREA_TYPE: { name:'ownership', dataType: 'text'},
  WATER_CONTROL: { name:'irrigation', dataType: 'text'},
  //DOC_STATUS: 1, //NA
  //CONTRACT_TYPE: 2, //NA
  DOC_TYPE_ID: { name:'deed_type_g', dataType: 'number'},
  DOC_NO: { name:'deed_no_g', dataType: 'text'},
  DOC_RAWANG: { name:'parcel_no', dataType: 'text'},
  DOC_RAI: { name:'deed_rai', dataType: 'number'},
  DOC_NGAN: { name:'deed_ngan', dataType: 'number'},
  DOC_WA: { name:'deed_sqwah', dataType: 'number' },
  //TAMBON_CODE1: {name:'aag5_fk', dataType: 'number' }, // use lfg_farmland.aag5_fk
  //MOO1: 1, //NA
  ACTIVITY_ID: { name:'orgc_ref', dataType: 'text' },
  // convert from database mis/cropcode?type=&name=
  //TYPE_CODE: { name:'type_fk', dataType: 'number' },
  TYPE_NAME: { name:'type_fk_g', dataType: 'text' },
  //DETAIL_CODE: { name:'genus_fk', dataType: 'number' },
  DETAIL_NAME: { name:'genus_fk_g', dataType: 'text' },
  //BREED_CODE: { name:'crop_fk', dataType: 'number' },
  BREED_NAME: { name:'crop_fk_g', dataType: 'text' },
  ACT_RAI: {name:'farm_rai', dataType: 'number' }, 
  ACT_NGAN: {name:'farm_ngan', dataType: 'number' }, 
  ACT_WA: {name:'farm_sqwah', dataType: 'number' }, 
  PLANT_DATE: {name:'grow_dt', dataType: 'date' },
  PRODUCE_DATE: {name:'harvest_dt', dataType: 'date' }
}

// required to save feature
export const dol_mapping = {
  provid: { name:'aac3_fk', dataType:'integer' },
  provname: { name:'province', dataType:'text' },
  amphurid: { name:'aac4_fk', dataType:'integer' },
  amphurname: { name:'amphoe', dataType:'text' },
  tumbolid: { name:'aac5_fk', dataType:'integer' },
  tumbol: { name:'tambon', dataType:'text' },
  rai: { name:'deed_rai', dataType:'integer' },
  ngan: { name:'deed_ngan', dataType:'integer' },
  wa: { name:'deed_sqwah', dataType:'integer' },
  subwa: { name:'deed_subwa', dataType:'integer' }, //??
  landoffice_id: { name:'land_office_id', dataType:'text' },
  landoffice: { name:'land_office_name', dataType:'text' },
  landofficelat: { name:'land_office_lat', dataType:'number' },
  landofficelon: { name:'land_office_lon', dataType:'number' },
  parcellat: { name:'wgs84_lat', dataType:'number' },
  parcellon: { name:'wgs84_lon', dataType:'number' },
  e: { name:'land_office_e', dataType:'number' },
  n: { name:'land_office_n', dataType:'number' },
  landno: { name:'parcel_no', dataType:'text' },
  landprice: { name:'land_price', dataType:'number' },
  regseq: { name:'reg_no', dataType:'text' },
  surveyno: { name:'survey_no', dataType:'text' },
  parcel_seq: { name:'parcel_seq', dataType:'text' },
  parcelno: { name:'deed_no_g', dataType:'text' },
  parcel_type: { name:'deed_type_g', dataType:'text' },
  zone: { name:'reg_no', dataType:'integer' },
  utm: { name:'utm', dataType:'text' },
  utm1: { name:'utm1', dataType:'integer' },
  utm2: { name:'utm2', dataType:'integer' },
  utm3: { name:'utm3', dataType:'integer' },
  utm4: { name:'utm4', dataType:'integer' },
  utmscale: { name:'utm_scale', dataType:'integer' }
}

// for data from upload
export const upload_mapping = {
  idcard: { name:'ssn_pk', dataType:'number' },
  prefix: { name:'title_th', dataType:'text' },
  firstname: { name:'name_th', dataType:'text' },
  surname: { name:'surname_th', dataType:'text' },
  pla_type: { name:'type_fk_g', dataType:'text' },
  pla_detail: { name:'genus_fk_g', dataType:'text' },
  pla_breed: { name: 'crop_fk_g', dataType:'text' },
  p_name: { name:'province', dataType:'text' },
  a_name: { name:'amphoe', dataType:'text' },
  t_name: { name:'tambon', dataType:'text' },
  doc_no: { name: 'deed_no_g', dataType: 'text'},
  doc_type: { name:'deed_type_g', dataType: 'text'},
  area_type: { name:'ownership', dataType: 'text'},
  wc_name: { name:'irrigation', dataType: 'text'},
  org_code: { name: 'org_code', dataType: 'text'},
  org_key: { name: 'org_key', dataType: 'text'}
}
